enum UserBookmarkShareFilterOption {
    PrivateOnly = 1,
    All,
}

export default UserBookmarkShareFilterOption;
